import {Material, Mesh, Object3D, Texture} from '@wonderlandengine/api';
import {createContext, useContext} from 'react';
import {UiTexturesManager} from '../components/ui-textures-manager.js';

export interface RotBMaterialContextValue {
    windowMaterial: Material;
    windowShadowMaterial: Material;

    buttonMaterial: Material;
    buttonShadowMaterial: Material;

    titleBackgroundMaterial: Material;
    gradientMaterial: Material;

    hudBarMaterial: Material;
    hudWindowMaterial: Material;

    regularTextMaterial: Material;

    uiTextShadowMaterial: Material;

    whiteBevelMaterial: Material;

    malReference: Object3D;
    planeReference: Mesh;

    cooldownMaterial: Material;
    circleTexture: Texture;

    buttonSimple: Texture;
    wordBalloonTail: Texture;
    wordBalloonTailRotated: Texture;
    wordBalloonTailFlipped: Texture;

    panelMaterialTexturedAlpha: Material;
}

export interface RotBHudMaterialContextValue {}

export let RotBMaterialContext = createContext<RotBMaterialContextValue | null>(null);

export let useRotBMaterialContext = () => useContext(RotBMaterialContext);
